import { Logo } from "@/components/brand/logo";

export function AuthShell({ title, subtitle, children }: { title: string; subtitle?: string; children: React.ReactNode }) {
  return (
    <main className="grid min-h-dvh lg:grid-cols-[1.05fr_1fr]">
      <section className="relative hidden overflow-hidden bg-foreground text-background lg:flex lg:flex-col lg:justify-between lg:p-12">
        <div className="lume-aura absolute inset-0 opacity-70" aria-hidden />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,hsl(0_0%_100%/0.07)_1px,transparent_0)] [background-size:22px_22px]" aria-hidden />
        <Logo className="relative text-background" />
        <div className="relative max-w-md">
          <p className="font-display text-4xl leading-[1.15] text-balance">
            Cada paciente atendido na hora, <em className="text-glow">com o cuidado</em> da sua clínica.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-background/70">
            Primeiro atendimento, agendamentos, lembretes e orientações de pré e pós — no WhatsApp, 24 horas por dia.
          </p>
        </div>
        <p className="relative text-xs text-background/50">© {new Date().getFullYear()} Lumë</p>
      </section>

      <section className="flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-sm">
          <Logo className="mb-10 lg:hidden" />
          <h1 className="font-display text-3xl tracking-tight">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </section>
    </main>
  );
}
